
import { SurveyTrigger } from '../screens/Components/EditDescriptionCard/EditDescriptionCard'

import {
    APISurveyObject,
  ApiSurveyTrigger,
  IAPISurveyQuestion,
  ISurveyQuestion,
  SurveyObject,
} from './ISurvey'

class Transformer {
  static transform(data: APISurveyObject): SurveyObject {
    return {
      id: data.id,
      establishment: data.establishment,
      name: data.name,
      mailSubject: data.mail_subject,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
      description: data.description,
      isSendAfterAppointment: data.send_after_appointment,
      sendDaysBeforeAppointment: data.send_days_before_appointment
        ? data.send_days_before_appointment
        : undefined,
      questions: data.questions.map(question => this.transformQuestion(question)),
      triggers: data.triggers.map(apiTrigger => this.transformTrigger(apiTrigger)),
      language: data.language,
    }
  }

  static transformQuestion(data: IAPISurveyQuestion): ISurveyQuestion {
    return {
      id: data.id,
      question: data.question,
      type: data.type,
      order: data.order,
      isMultipleChoice: !!data.is_multiple_choice,
      isMultiline: !!data.is_multiline,
      choices:
        data.choices === undefined
          ? []
          : data.choices.map(choice => choice.name),
    }
  }

  static transformTrigger(trigger: ApiSurveyTrigger): SurveyTrigger {
    const typeCheck = trigger.type
    const commonObject = { 
      uuid: trigger.uuid,
      frequency: trigger.frequency,
     }

    if(typeCheck === 'send_after_appointment'){
      return({
        ...commonObject,
        type: trigger.type,
        activityUuids: trigger.activities.length > 0
            ? trigger.activities.map(
                triggerActivity => triggerActivity.activity.uuid,
              )
            : [],
        categoryIds:
          trigger.categories.length > 0
            ? trigger.categories.map(
                triggerCategory => triggerCategory.category.id,
              )
            : [],
      })
    }

      return({
        ...commonObject,
        type: trigger.type,
        amount: trigger.amount,
      })
  }

  static reverseTransformQuestion(
    question: ISurveyQuestion,
  ): IAPISurveyQuestion {
    return {
      id: question.id,
      question: question.question,
      type: question.type,
      order: question.order,
      is_multiline: !!question.isMultiline,
      is_multiple_choice: !!question.isMultipleChoice,
      choices:
        question.choices === undefined
          ? []
          : question.choices.map(choice => {
              return { name: choice }
            }),
    }
  }
}

export default Transformer
